import { render, staticRenderFns } from "./ProductBranchAvailability.vue?vue&type=template&id=22fcf834&scoped=true&"
import script from "./ProductBranchAvailability.vue?vue&type=script&lang=js&"
export * from "./ProductBranchAvailability.vue?vue&type=script&lang=js&"
import style0 from "./ProductBranchAvailability.vue?vue&type=style&index=0&id=22fcf834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fcf834",
  null
  
)

export default component.exports